import React, { useState, useEffect, useContext } from "react";
import { Link, withRouter } from "react-router-dom";
import { Form, Input, Icon, Drawer, Tooltip, Upload, Select, Checkbox, notification } from "antd";
import { GlobalContext } from "../../../../app/providers/GlobalState";
import ModalViewer from "../../../../shared/components/Modals/ModalViewer";
import axios from "axios";
import moment from "moment";

const openNotificationWithIcon = (type, message, description) => {
    notification[type]({
        message: message,
        description: description
    });
};

const DrawerPagamento = ({ extensions, dividaId, visible, atualizar, onClose, form, match }) => {
    const globalContext = useContext(GlobalContext);
    const [tipos, setTipos] = useState([]);
    const [tiposPagamento, setTiposPagamento] = useState([]);
    const [formData, setFormData] = useState({
        tipo: undefined,
        tipoPagamento: undefined,
        descricao: "",
        pago: false,
        valor: 0,
        comprovativo: "",
        comprovativoLink: "",
        comprovativoExtensao: ""
    });
    const [fileList, setFileList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [ficheiros, setFicheiros] = useState([]);
    const [docs, setDocs] = useState([]);
    const [modalVisible, setModalVisible] = useState(false);

    const { getFieldDecorator } = form;
    const Dragger = Upload.Dragger;
    const { Option } = Select;
    const { TextArea } = Input;

    const carregarTipos = () => {
        axios({
            method: "get",
            url: "/api/user-detalhe/carregar-tipos-divida"
        })
            .then(respose => {
                setTipos(respose.data);
            })
            .catch(error => {
                openNotificationWithIcon("error", "Erro", error.response.data);
            });
    };

    const carregarTiposPagamento = () => {
        axios({
            method: "get",
            url: "/api/user-detalhe/carregar-tipos-pagamento-divida"
        })
            .then(respose => {
                setTiposPagamento(respose.data);
            })
            .catch(error => {
                openNotificationWithIcon("error", "Erro", error.response.data);
            });
    };

    const detalhe = () => {
        axios({
            method: "get",
            url: "/api/user-detalhe/carregar-divida",
            params: {
                dividaId
            }
        })
            .then(response => {
                const info = response.data.dividaInfo;
                setFormData({
                    tipo: info.id_tipo,
                    tipoPagamento: info.id_tipo_pagamento,
                    descricao: info.descricao,
                    pago: info.pago,
                    valor: info.valor
                });
                setFicheiros(response.data.ficheiros);
            })
            .catch(error => {
                openNotificationWithIcon("error", "Erro", error.response.data);
            });
    };

    const adicionar = () => {
        form.validateFieldsAndScroll((err, values) => {
            if (!err) {
                setLoading(true);

                var item = new FormData();
                item.append("code", match.params.code);
                item.append("id_tipo", formData.tipo);
                item.append("id_tipo_pagamento", formData.tipoPagamento);
                item.append("descricao", formData.descricao);
                item.append("pago", formData.pago);
                item.append("valor", formData.valor);
                fileList.forEach(file => {
                    item.append("anexo[]", file);
                });

                axios({
                    method: "post",
                    url: "/api/user-detalhe/adicionar-divida",
                    data: item
                })
                    .then(() => {
                        openNotificationWithIcon("success", "Sucesso", "Ação efetuada com sucesso!.");
                        setLoading(false);
                        atualizar();
                    })
                    .catch(error => {
                        openNotificationWithIcon("error", "Erro", error.response.data);
                        setLoading(false);
                    });
            }
        });
    };

    const alterar = () => {
        form.validateFieldsAndScroll((err, values) => {
            if (!err) {
                setLoading(true);

                var item = new FormData();
                item.append("id", dividaId);
                item.append("id_tipo", formData.tipo);
                item.append("id_tipo_pagamento", formData.tipoPagamento);
                item.append("descricao", formData.descricao);
                item.append("pago", formData.pago);
                item.append("valor", formData.valor);
                if (ficheiros.length) item.append("listaFicheiros", JSON.stringify(ficheiros));
                fileList.forEach(file => {
                    item.append("anexo[]", file);
                });

                axios({
                    method: "put",
                    url: "/api/user-detalhe/alterar-divida",
                    data: item
                })
                    .then(() => {
                        openNotificationWithIcon("success", "Sucesso", "Ação efetuada com sucesso!.");
                        setLoading(false);
                        atualizar();
                    })
                    .catch(error => {
                        openNotificationWithIcon("error", "Erro", error.response.data);
                        setLoading(false);
                    });
            }
        });
    };

    const afterVisibleChange = visible => {
        form.resetFields();
        if (visible) {
            if (dividaId > 0) detalhe();
        } else {
            setFormData({
                tipo: undefined,
                tipoPagamento: undefined,
                descricao: "",
                pago: false,
                valor: 0,
                comprovativo: "",
                comprovativoLink: ""
            });
            setFileList([]);
            setLoading(false);
        }
    };

    const validarFormatoFicheiro = formato => {
        var formatos = [
            "docx",
            "doc",
            "pdf",
            "odf",
            "txt",
            "rtf",
            "xlsx",
            "xls",
            "csv",
            "ods",
            "pptx",
            "ppt",
            "odp",
            "bmp",
            "gif",
            "png",
            "jpeg",
            "jpg"
        ];
        var valido = false;
        for (var i = 0; i < formatos.length; i++) {
            if (formato.toLowerCase() === formatos[i]) {
                valido = true;
                break;
            }
        }
        return valido;
    };

    const validar = (rule, value, callback) => {
        if (value.file)
            if (!validarFormatoFicheiro(value.file.name.split(".").pop().toLowerCase()) && value.file.status !== "removed")
                callback("Ficheiro com formato inválido");
            else if (value.file.status === "removed") callback("Campo obrigatório");

        callback();
    };

    const props = {
        multiple: true,
        onRemove: file => {
            form.resetFields("ficheiro");
            setFileList(fileList => {
                const index = fileList.indexOf(file);
                const newFileList = fileList.slice();
                newFileList.splice(index, 1);

                return newFileList;
            });
        },
        defaultFileList: fileList,
        beforeUpload: file => {
            setFileList(fileList => [...fileList, file]);

            return false;
        },
        fileList
    };

    const validarValor = (rule, value, callback) => {
        if (isNaN(value)) callback("O valor deve ser um número");

        callback();
    };

    const download = (nome, url) => {
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", nome);

        document.body.appendChild(link);

        link.click();

        link.parentNode.removeChild(link);
    };

    useEffect(() => {
        carregarTipos();
        carregarTiposPagamento();
    }, []);

    return (
        <Drawer
            className="drawer-add-cursos drawer-videoconferencias"
            //title=""
            width={720}
            onClose={onClose}
            visible={visible}
            style={{
                overflow: "auto",
                height: "calc(100% - 108px)",
                paddingBottom: "108px"
            }}
            maskClosable={false}
            afterVisibleChange={afterVisibleChange}
        >
            <div className="bloco-info">
                <Form className="form-categorias" layout="horizontal">
                    <div className="bloco">
                        <Form.Item label="Tipo">
                            {getFieldDecorator("tipo", {
                                rules: [
                                    {
                                        required: true,
                                        message: "Campo obrigatório"
                                    }
                                ],
                                initialValue: formData.tipo
                            })(
                                <Select
                                    className="input-50"
                                    placeholder="Selecionar"
                                    allowClear={true}
                                    onChange={tipo => setFormData({ ...formData, tipo })}
                                >
                                    {tipos.map(tipo => (
                                        <Option key={tipo.id} value={tipo.id}>
                                            {tipo.titulo}
                                        </Option>
                                    ))}
                                </Select>
                            )}
                        </Form.Item>
                        <Form.Item label="Método de pagamento">
                            {getFieldDecorator("tipoPagamento", {
                                rules: [
                                    {
                                        required: true,
                                        message: "Campo obrigatório"
                                    }
                                ],
                                initialValue: formData.tipoPagamento
                            })(
                                <Select
                                    className="input-50"
                                    placeholder="Selecionar"
                                    allowClear={true}
                                    onChange={tipoPagamento => setFormData({ ...formData, tipoPagamento })}
                                >
                                    {tiposPagamento.map(tipo => (
                                        <Option key={tipo.id} value={tipo.id}>
                                            {tipo.titulo}
                                        </Option>
                                    ))}
                                </Select>
                            )}
                        </Form.Item>
                        <Form.Item label="Descrição">
                            {getFieldDecorator("descricao", {
                                initialValue: formData.descricao
                            })(
                                <TextArea
                                    name="descricao"
                                    onChange={e => setFormData({ ...formData, descricao: e.target.value })}
                                    rows={4}
                                    style={{ height: 100 }}
                                />
                            )}
                        </Form.Item>
                        <Form.Item label="Valor">
                            {getFieldDecorator("valor", {
                                rules: [
                                    {
                                        validator: validarValor
                                    }
                                ],
                                initialValue: formData.valor
                            })(
                                <Input
                                    className="input-50"
                                    name="valorCurso"
                                    onChange={e => setFormData({ ...formData, valor: e.target.value })}
                                    prefix={globalContext.moeda_entidade}
                                />
                            )}
                        </Form.Item>
                    </div>
                    <div className="bloco">
                        <h3 className="titulo-separador" style={{ marginBottom: "20px" }}>
                            Documentos
                        </h3>
                        {ficheiros.map(ficheiro => (
                            <Form.Item>
                                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                                    <span>{ficheiro.nome}</span>
                                    <span style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 10 }}>
                                        {extensions.find(x => x === ficheiro.extensao) && (
                                            <Link
                                                to="#"
                                                title="Visualizar"
                                                className="botao-icon-detalhe"
                                                onClick={() => {
                                                    setModalVisible(true);
                                                    setDocs([{ uri: ficheiro.url }]);
                                                }}
                                            >
                                                <Icon type="eye" />
                                            </Link>
                                        )}
                                        <Link
                                            to="#"
                                            title="Descarregar"
                                            className="botao-icon-download"
                                            onClick={() => download(ficheiro.nome, ficheiro.url)}
                                        >
                                            <Icon type="download" />
                                        </Link>
                                        <Link
                                            className="botao-icon-excluir"
                                            to="#"
                                            title="Excluir"
                                            onClick={() => setFicheiros([...ficheiros.filter(x => x.id !== ficheiro.id)])}
                                        >
                                            <Icon type="delete" />
                                        </Link>
                                    </span>
                                </div>
                            </Form.Item>
                        ))}
                        <Form.Item>
                            <div className="anexos">
                                {getFieldDecorator("ficheiro", {
                                    rules: [
                                        {
                                            validator: validar
                                        }
                                    ],
                                    initialValue: fileList
                                })(
                                    <Dragger {...props}>
                                        <p className="ant-upload-drag-icon">
                                            <i className="fas fa-upload" />
                                        </p>
                                        <p className="ant-upload-text">
                                            Adicionar anexo{" "}
                                            <Tooltip title="Formatos válidos: .zip, .rar, .7z, .docx, .doc, .pdf, .odf, .txt, .rtf, .xlsx, .xls, .csv, .ods, .pptx, .ppt, .odp, .bmp, .gif, .png, .jpeg, .jpg">
                                                <Icon type="question-circle-o" />
                                            </Tooltip>
                                        </p>
                                        <p className="ant-upload-hint">Limite de 25MB por upload</p>
                                    </Dragger>
                                )}
                            </div>
                        </Form.Item>
                        <Form.Item>
                            {getFieldDecorator("pago", {
                                initialValue: formData.pago
                            })(
                                <Checkbox
                                    name="pago"
                                    checked={formData.pago}
                                    onChange={e => setFormData({ ...formData, pago: e.target.checked })}
                                >
                                    Pago
                                </Checkbox>
                            )}
                        </Form.Item>
                    </div>
                </Form>
            </div>
            <div className="ant-drawer-footer">
                <Link to="#" className="botao-secundario" onClick={onClose} style={{ marginRight: 20, display: "inline-block" }}>
                    Voltar
                </Link>
                <button className="botao-principal" disabled={loading} onClick={dividaId > 0 ? alterar : adicionar}>
                    {loading ? <Icon type="loading" /> : null}
                    Salvar
                </button>
            </div>
            <ModalViewer visible={modalVisible} docs={docs} onCancel={() => setModalVisible(false)} />
        </Drawer>
    );
};

const FormDrawerPagamento = Form.create({ name: "form-drawer-pagamento" })(DrawerPagamento);

export default withRouter(FormDrawerPagamento);
